import React, { useReducer, useEffect, useContext, useState } from "react";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { Alert, Button, Card, Col, Modal, Row, Table } from "react-bootstrap";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../config/toastNotification";
import axios from "../../../config/axios";
import BlockSuccessMessage from "../../UI/errorMessages/BlockSuccessMessage";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import CMSFormMultiSelect from "../../UI/forms/CMSFormMultiSelect";
import {
    updateInitialState,
    updateReducer,
} from "./reducers/updateReducer";
import CMSFormInput from "../../UI/forms/CMSFormInput";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import CMSFormSelect from "../../UI/forms/CMSFormSelect";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import { listingInitialState, listingReducer } from "./reducers/listingReducer";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import moduleConfig from "./moduleConfig";
import { getInitialItem, getObjectByTitle } from "../../../helpers/CommonHelper";
import { createInitialState, createReducer } from "./reducers/createReducer";
const ActivityRegistrationImport = () => {
    let { id } = useParams();
    const location = useLocation();
    const file = location.state;
    let breadcrumbs = {
        listing: {
            label: "Activities",
            url: `/activities`,
        },
        details: {
            label: "Attendees",
            url: `/activities/${moduleConfig.url}/${id}`,
        },
        attendees: {
            label: "Users",
            url: `/activity-registrations/${id}`,
        },

        import: {
            label: "Import",
        },
    };
    const { setBreadcrumb } = useContext(BreadcrumbContext);
    let navigate = useNavigate();

    const [state, dispatch] = useReducer(createReducer, createInitialState);
    const [deleteState, deleteDispatch] = useReducer(listingReducer, listingInitialState);
    ;
    
    
    const handleFormatArray = (item) => {
        const array = [{ label: "Select CSV Column", value: "" }];
        for (let i = 0; i < item.length; i++) {
            array.push({ label: item[i], value: item[i] });
        }

        return array;
    };
    function findKeyValue(targetString) {
        const dataDict = file[0];
        const lowerCaseTargetString =
            removeSpecialCharacters(targetString).toLowerCase();
        for (const key in dataDict) {
            removeSpecialCharacters(key);
            if (
                removeSpecialCharacters(key)
                    .toLowerCase()
                    .includes(lowerCaseTargetString)
            ) {
                return key;
            }
        }

        return "";
    }
    function removeSpecialCharacters(text) {
        // Regular expression to match underscores, hyphens, commas, and spaces
        const regex = /[_\-,\s]/g;
        // Use the replace method with the regex to remove matched characters
        return text.replace(regex, "");
    }

    useEffect(() => {
        setBreadcrumb([
            breadcrumbs.listing,
            breadcrumbs.details,
            breadcrumbs.attendees,
            breadcrumbs.import,
        ]);
        dispatch({
            type: "FETCH_SUCCESS",
            payload: [],
        });

       
    }, []);


    const onSubmit = async (data) => {
        dispatch({
            type: "FORM_SUBMISSION_REQUEST",
        });
        console.log("inside submit")
        try {
            const res = await axios.post(
                `activity-registrations/import/${id}`,
                { data: data }
            ); //

            dispatch({
                type: "FORM_SUBMISSION_SUCCESS",
                payload: res.data,
            });

            // navigate(`/activities/${moduleConfig.url}/${id}`);
            toast.addNotification({
                ...toastNotification,
                title: "Success!",
                message: `Attendee created successfully.`,
                type: "success",
            });
        } catch (error) {
            const status = error.response ? error.response.status : 500;
            const errorMessage =
                status === 400 ? error.response.data.message : error.message;

            dispatch({
                type: "FORM_SUBMISSION_FAILURE",
                payload: errorMessage,
            });
            setTimeout(() => {
                dispatch({
                    type: "FORM_INITIAL_STATE",
                });
            }, 5000);
        }
    };
    const handleDeleteImported = async (data) => {
        deleteDispatch({
            type: "DELETE_REQUEST",
        });
        try {
            const res = await axios.post(`activity-registrations/delete-imported/${id}`, { ids: data });

            toast.addNotification({
                ...toastNotification,
                title: "Success!",
                message: `Attendees deleted successfully.`,
                type: "success",
            });
            navigate(`/activity-registrations/${id}`)
        } catch (error) {
            deleteDispatch({
                type: "DELETE_FAILURE",
                payload: error,
            });

            setTimeout(() => {
                deleteDispatch({
                    type: "REMOVE_ERROR",
                });
            }, 5000);
        }
    };

    return (
        <DashboardLayout>
            {deleteState.isFetching && (
                <div class="overlay position-absolute containerLoading">
                    <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                </div>
            )}

            <ModuleHeader
                moduleTitle="Import Attendee"
            >

            </ModuleHeader>
            {file && file[0] &&  !state.isSubmitted && (
                <Card>
                    {state.isLoading && (
                        <div class="overlay position-absolute containerLoading">
                            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                        </div>
                    )}
                    <Card.Body>
                        <Formik
                            initialValues={{
                                activityId: id,
                                email: findKeyValue("email"),
                                partnerParticipating: findKeyValue("partnerParticipating"),
                                guestsParticipating: findKeyValue("guestsParticipating"),
                                kidsParticipating: findKeyValue("kidsParticipating"),
                                amount: findKeyValue("amount"),
                                paymentStatus: findKeyValue("paymentStatus"),
                                adminNotes: findKeyValue("adminNotes"),
                            }}
                            enableReinitialize={true}
                            validateOnChange={true}
                            validateOnBlur={true}
                            onSubmit={(values, { resetForm }) => {
                                const mapping = values;
                                console.log(values)
                                file.pop();
                                function transformArray() {
                                    return file.map(item => {
                                        const newItem = {};
                                        Object.entries(mapping).forEach(([key, value]) => { // Destructure key and value
                                            // Skip processing for 'peopleGroup'
                                            if (key === 'activityId' || key === 'peopleGroup' || key === "status" || key === "partnerId" || key === "sponsorId") {
                                                console.log("key", mapping[key]);
                                                // Correctly assign the value of 'peopleGroup' from the item
                                                newItem[key] = value;
                                            } else {
                                                // For other keys, check if the item has the property mapped by the value
                                                if (item.hasOwnProperty(value)) {
                                                    newItem[key] = item[value];
                                                } else {
                                                    newItem[key] = ''; // Default to empty string if not found
                                                }
                                            }
                                        });
                                        return newItem;
                                    });
                                }

                                const transformedArray = transformArray();
                                console.log(file, transformedArray)
                                onSubmit(transformedArray)

                            }}
                        >
                            {(form) => (
                                <>
                                    {state.error && state.status === "fetchFailed" ? (
                                        <BlockErrorMessage error={state.error} />
                                    ) : (
                                        <>
                                            <Form onSubmit={form.handleSubmit}>
                                                {state.error && (
                                                    <div className="px-3 my-2">
                                                        <FormErrorMessage error={state.error} />
                                                    </div>
                                                )}

                                                <>

                                                    <>
                                                         
                                                        <Row>
                                                            <Col
                                                                xl={2}
                                                                lg={2}
                                                                md={3}
                                                                xs={4}
                                                                sm={4}
                                                                className="text-bold"
                                                            >
                                                                Email
                                                            </Col>
                                                            <Col xl={4} lg={2} md={3} xs={4} sm={4}>
                                                                <CMSFormSelect showGeneral={false}
                                                                    name="email"
                                                                    form={form}
                                                                    options={
                                                                        file[0] && handleFormatArray(Object.keys(file[0]))
                                                                    }
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col
                                                                xl={2}
                                                                lg={2}
                                                                md={3}
                                                                xs={4}
                                                                sm={4}
                                                                className="text-bold"
                                                            >
                                                                Partner Participating
                                                            </Col>
                                                            <Col xl={4} lg={2} md={3} xs={4} sm={4}>
                                                                <CMSFormSelect showGeneral={false}
                                                                    name="partnerParticipating"
                                                                    form={form}
                                                                    options={
                                                                        file[0] && handleFormatArray(Object.keys(file[0]))
                                                                    }
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col
                                                                xl={2}
                                                                lg={2}
                                                                md={3}
                                                                xs={4}
                                                                sm={4}
                                                                className="text-bold"
                                                            >
                                                                Guests Participating
                                                            </Col>
                                                            <Col xl={4} lg={2} md={3} xs={4} sm={4}>
                                                                <CMSFormSelect showGeneral={false}
                                                                    name="guestsParticipating"
                                                                    form={form}
                                                                    options={
                                                                        file[0] && handleFormatArray(Object.keys(file[0]))
                                                                    }
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col
                                                                xl={2}
                                                                lg={2}
                                                                md={3}
                                                                xs={4}
                                                                sm={4}
                                                                className="text-bold"
                                                            >
                                                                Kids Participating
                                                            </Col>
                                                            <Col xl={4} lg={2} md={3} xs={4} sm={4}>
                                                                <CMSFormSelect showGeneral={false}
                                                                    name="kidsParticipating"
                                                                    form={form}
                                                                    options={
                                                                        file[0] && handleFormatArray(Object.keys(file[0]))
                                                                    }
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col
                                                                xl={2}
                                                                lg={2}
                                                                md={3}
                                                                xs={4}
                                                                sm={4}
                                                                className="text-bold"
                                                            >
                                                                Amount
                                                            </Col>
                                                            <Col xl={4} lg={2} md={3} xs={4} sm={4}>
                                                                <CMSFormSelect showGeneral={false}
                                                                    name="amount"
                                                                    form={form}
                                                                    options={
                                                                        file[0] && handleFormatArray(Object.keys(file[0]))
                                                                    }
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col
                                                                xl={2}
                                                                lg={2}
                                                                md={3}
                                                                xs={4}
                                                                sm={4}
                                                                className="text-bold"
                                                            >
                                                                Payment Status
                                                            </Col>
                                                            <Col xl={4} lg={2} md={3} xs={4} sm={4}>
                                                                <CMSFormSelect showGeneral={false}
                                                                    name="paymentStatus"
                                                                    form={form}
                                                                    options={
                                                                        file[0] && handleFormatArray(Object.keys(file[0]))
                                                                    }
                                                                />
                                                            </Col>
                                                        </Row>

                                                        <Row>
                                                            <Col
                                                                xl={2}
                                                                lg={2}
                                                                md={3}
                                                                xs={4}
                                                                sm={4}
                                                                className="text-bold"
                                                            >
                                                                Admin Notes
                                                            </Col>
                                                            <Col xl={4} lg={2} md={3} xs={4} sm={4}>
                                                                <CMSFormSelect showGeneral={false}
                                                                    name="adminNotes"
                                                                    form={form}
                                                                    options={
                                                                        file[0] && handleFormatArray(Object.keys(file[0]))
                                                                    }
                                                                />
                                                            </Col>
                                                        </Row>
                                                        

                                                    </>

                                                    <Button variant="primary" type="submit">
                                                        Submit
                                                    </Button>
                                                </>
                                            </Form>
                                        </>
                                    )}
                                </>
                            )}
                        </Formik>
                    </Card.Body>
                </Card>
            )}
            {state.isSubmitted && state.data && state.data.data && <>


                <Row>
                    <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                        <Card className="mb-0 p-1">
                            <Row className="d-flex align-items-center justify-content-end">
                                <Col>
                                    {/* <h4 className=" mb-2 p-3"> Failed Contacts</h4> */}
                                </Col>
                                <Col xl={3} className="d-flex align-items-center justify-content-end">
                                    <Link to={`/activity-registrations/${id}`} className="btn btn-primary my-2">
                                        View Registrations
                                    </Link>
                                </Col>
                            </Row>
                            <Table striped bordered hover className="mb-0">

                                <tbody>

                                    <tr>
                                        <td>Total Items</td>
                                        <td>{state.data.data.totalItems}</td>
                                    </tr>
                                    <tr>
                                        <td>Imported Items</td>
                                        <td>{state.data.data.savedItems}</td>
                                    </tr>
                                    <tr>
                                        <td>Failed Items</td>
                                        <td>{state.data.data.failedItems}</td>
                                    </tr>
                                    <tr>
                                        <td>Not Fund Members</td>
                                        <td>{state.data.data.notFundMembers.length}</td>
                                    </tr>
                                    {(state.data.data.notFundMembers && state.data.data.notFundMembers.length > 0 ) && state.data.data.notFundMembers.map((item) => {
                                        return (
                                            <>
                                                <tr>
                                                    <td></td>
                                                    <td>{item.email}</td>
                                                </tr>
                                            </>
                                        )
                                    })}

                                    <tr>
                                        <td>Already Registered Members</td>
                                        <td>{state.data.data.alreadyRegisteredMembers.length}</td>

                                    </tr>
                                    {(state.data.data.alreadyRegisteredMembers && state.data.data.alreadyRegisteredMembers.length > 0) && state.data.data.alreadyRegisteredMembers.map((item) => {
                                        return (
                                            <>
                                                <tr>
                                                    <td></td>
                                                    <td>{item.email}</td>
                                                </tr>
                                            </>
                                        )
                                    })}

                                    

                                </tbody>
                            </Table>
                        </Card>
                    </Col>


                </Row>


            </>}
        </DashboardLayout>
    );
};

export default ActivityRegistrationImport;
